/* eslint-disable max-len */
/**@deprecated */
export const ALERT_EVERY_MINUTE_AND_ORDER_ENTITY_LEAD_TIME_COMPARING_ERROR =
  '"Alert Every <n> Minute(s), after Lead Time" value should be less than "Order Entry Lead Time".';

/**@deprecated */
export const ORDER_ENTITY_LEAD_TIME_AND_OVERDUE_TIME_COMPARING_ERROR =
  '"Order Entry Lead Time" value should be greater than "Order Entry Overdue Time".';
/**@deprecated */
export const JOB_CODES_UNIQUENESS_ERROR =
  'Each Job Code must be unique within one Payrule Group.';

// Unit tests error messages mocks
export const DEFAULT_ERROR_MOCK = 'Error message';
export const ANOTHER_ERROR_MOCK = 'Another Error message';
export const BAD_REQUEST_ERROR = 'Bad request';
export const CONNECTION_ERROR = 'Connection error';

export const GET_NONE_VALUE_ERROR =
  'GetValue RxJs helper - cannot read value from asynchronous Observable source';
/* eslint-enable max-len */
